export default function ({ $auth, app, redirect }) {
  if (!$auth.loggedIn && !app.$useConfig(app.$EClientConfig.ENABLE_PUBLIC_SEARCH)) {
    redirect(app.$link.signup())
  }
}
